module.exports = __webpack_public_path__ + "img/new_index_cases24.db80181d.png";